/**
 * 接口请求规范：https://hhy5wymu76.feishu.cttq.com/wiki/wikb6kDZbV27tiV1JF68g13Ovvh
 */
import { Request } from "@cttq/cttq-request";
const getHeader = () => {
	const headers = {
		appSource: import.meta.env.VITE_SOURCE,
		reqSource: "pc",
		userCode: localStorage.getItem("account"),
		userName: encodeURI(localStorage.getItem("userName") || "")
	};
	return headers;
};

const BaseRequestInstance = new Request({
	baseURL: import.meta.env.VITE_SMS_URL,
	showLoading: false,
	showError: true,
	timeout: 180000,
	cancelRequest: true,
	headers: getHeader(),
	requestInterceptors: (config: any) => {
		// 请求拦截器
		return config;
	}
	// responseInterceptors: (response: any) => {
	// 	// 响应拦截器
	// 	return response.data;
	// }
});

const AccountRequestInstance = new Request({
	baseURL: import.meta.env.VITE_ACCOUNT_URL,
	showLoading: false,
	showError: true,
	timeout: 180000,
	cancelRequest: true,
	headers: getHeader(),
	requestInterceptors: (config: any) => {
		// 请求拦截器
		return config;
	}
	// responseInterceptors: (response: any) => {
	// 	// 响应拦截器
	// 	return response.data;
	// }
});

const HideErrorRequestInstance = new Request({
	baseURL: import.meta.env.VITE_SMS_URL,
	showLoading: false,
	showError: false,
	timeout: 180000,
	cancelRequest: true,
	headers: getHeader(),
	requestInterceptors: (config: any) => {
		// 请求拦截器
		return config;
	}
	// responseInterceptors: (response: any) => {
	// 	// 响应拦截器
	// 	return response.data;
	// }
});

export { BaseRequestInstance, HideErrorRequestInstance, AccountRequestInstance };
